import React, { useState } from "react";
import axios from "axios";
import { Mail, Check } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const NewsletterSignup = () => {
    const [email, setEmail] = useState("");
    const [err, setErr] = useState("");
    const [busy, setBusy] = useState(false);
    const [ok, setOk] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setErr("Enter a valid email.");
            return;
        }
        setBusy(true);
        try {
            await axios.post(`${API}/newsletter`, { email }, { timeout: 12000 });
            setOk(true);
            setEmail("");
        } catch (e2) {
            setErr(e2?.response?.data?.detail || "Something went wrong. Try again in a moment.");
        } finally {
            setBusy(false);
        }
    };

    return (
        <section className="section" data-testid="newsletter-signup" style={{ background: "var(--surface)" }}>
            <div className="container">
                <div className="newsletter-card">
                    <div>
                        <span className="eyebrow">Monthly operator insights</span>
                        <h2 className="h2" style={{ marginTop: 14, fontSize: "1.75rem" }}>One thoughtful email a month for SME operators.</h2>
                        <p className="muted" style={{ maxWidth: 520, marginTop: 8 }}>
                            Patterns we see across hundreds of growing businesses. No fluff, no listicles, no sales pitches.
                        </p>
                    </div>
                    {ok ? (
                        <div className="newsletter-success" data-testid="newsletter-success">
                            <span className="check-circle" style={{ width: 48, height: 48, marginBottom: 12 }}>
                                <Check size={22} />
                            </span>
                            <strong>You're in.</strong>
                            <p className="muted" style={{ marginTop: 6, fontSize: "0.9rem" }}>
                                First note lands at month-end.
                            </p>
                        </div>
                    ) : (
                        <form onSubmit={submit} className="newsletter-form" data-testid="newsletter-form" noValidate>
                            <div className="newsletter-row">
                                <Mail size={16} className="newsletter-icon" />
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => { setEmail(e.target.value); setErr(""); }}
                                    placeholder="you@yourcompany.com"
                                    aria-label="Email address"
                                    data-testid="newsletter-input"
                                />
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={busy}
                                    data-testid="newsletter-submit-btn"
                                >
                                    {busy ? "Subscribing…" : "Subscribe"}
                                </button>
                            </div>
                            {err && <div className="err" data-testid="newsletter-error" style={{ marginTop: 8 }}>{err}</div>}
                        </form>
                    )}
                </div>
            </div>
        </section>
    );
};

export default NewsletterSignup;
